import { Partition } from '@snapchat/graphene';
import { type BackgroundColor, MotifScheme } from '@snapchat/snap-design-system-marketing';

import { Feature } from '../../components/FeatureFlags';
import type { SiteConfiguration } from '../../configTypes';
import { LoggingVendor } from '../../helpers/logging/eventListenerTypes';
import { CustomLocaleDropdownButton } from './components/CustomLocaleDropdownButton/CustomLocaleDropdownButton';
import { customHeaderCss, footerBarCss, footerBarWrapperCss } from './snapConfig.styles';

export const config: SiteConfiguration = {
  domainName: 'snap.com',

  featureFlags: {
    [Feature.USE_SNAP_MOTIF]: 'true',
  },

  theme: {
    defaultCarouselOverflowDecoration: true,
  },

  globalNavProps: {
    defaultGroupKey: 'snap',
  },
  trackingSettings: {
    eventListeners: [
      { vendor: LoggingVendor.BLIZZARD },
      { vendor: LoggingVendor.CONSOLE },
      { vendor: LoggingVendor.GOOGLE_CLOUD_LOGGING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_MONITORING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_ERROR_REPORTING },
      { vendor: LoggingVendor.GRAPHENE, partitionName: Partition.SNAP_WEB },
      {
        vendor: LoggingVendor.GOOGLE_TAG_MANAGER,
        googleTagManagerId: 'GTM-PB72WQ3',
        googleAnalyticsId: 'G-LJY98QLWYT',
      },
      {
        vendor: LoggingVendor.SENTRY,
        projectName: 'snap',
        dsn: 'https://fdd828e30c9c423cb0653ae452415f77@sentry.sc-prod.net/81',
      },
    ],
  },
  csp: {
    connectSrc: [
      'https://newsroom.snap.com', // Newsroom block integration
    ],
  },
  customHeaderFooterRoutes: [
    {
      slug: '/',
      customGlobalNavProps: {
        /**
         * BackgroundColor is processed by the SDS-M getBackgroundClassName utility. By setting it
         * to MotifScheme.QUINARY, the header uses the sdsm-quinary motif scheme.
         */
        backgroundColor: MotifScheme.QUINARY as unknown as BackgroundColor,
        addBottomBorder: true,
        lessMargins: true,
        headerClassName: customHeaderCss,
      },
      customFooterProps: {
        /**
         * BackgroundColor is processed by the SDS-M getBackgroundClassName utility. By setting it
         * to MotifScheme.QUINARY, the footer uses the sdsm-quinary motif scheme.
         */
        backgroundColor: MotifScheme.QUINARY as unknown as BackgroundColor,
        fullWidthFooterBar: true,
        footerBarWrapperClassName: footerBarWrapperCss,
        footerBarClassName: footerBarCss,
        customLocaleDropdownButton: CustomLocaleDropdownButton,
      },
    },
  ],
};
